import React, { lazy } from 'react';
import { useInView } from '../hooks/useInView';
export function FrecuenciaSection() {
  const listItems = ['Sincronización Hemisférica.', 'Eliminación de Cortisol Financiero.', 'Activación de la Intuición de Negocios.'];
  const [imgRef, imgInView] = useInView();
  const [textRef, textInView] = useInView();
  return <section id="la-frecuencia" className="py-16 sm:py-24 px-4 sm:px-[5%] bg-[#0A0A0B] relative border-t border-white/5" data-id="element-67">
      <div className="max-w-[1200px] mx-auto" data-id="element-68">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-center" data-id="element-69">
          {/* Image */}
          <div ref={imgRef} className={`order-2 lg:order-1 relative will-animate animate-slideLeft ${imgInView ? 'is-visible' : ''}`} data-id="element-70">
            <img src="https://cdn.magicpatterns.com/uploads/4C5gsp8MKrBMjywxbTG9X3/la-frecuencia-888-visualizacion-del-sonido.webp" alt="Visualización cymatics de la frecuencia 888Hz mostrando patrones de geometría sagrada" width={600} height={400} loading="lazy" decoding="async" className="w-full rounded-xl border border-gold/30 shadow-[0_0_40px_rgba(212,175,55,0.1)] relative z-10 aspect-[3/2]" data-id="element-71" />
          </div>

          {/* Text */}
          <div ref={textRef} className={`order-1 lg:order-2 text-center lg:text-left will-animate animate-slideRight ${textInView ? 'is-visible' : ''}`} data-id="element-72">
            <h2 className="font-serif text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-73">
              El Orden del <br className="hidden lg:block" data-id="element-74" />
              <span className="text-gold" data-id="element-75">Oro Líquido</span>
            </h2>

            <p className="text-lg opacity-90 leading-relaxed mb-8" data-id="element-76">
              La frecuencia de 888Hz genera patrones de geometría sagrada en el
              agua de tus células. Donde antes había caos y deuda, el Código 888
              introduce{' '}
              <strong className="text-white font-bold" data-id="element-77">Orden y Fluidez</strong>.
            </p>

            <ul className="space-y-4 text-left inline-block lg:block" data-id="element-78">
              {listItems.map((item, index) => <li key={index} className={`flex items-center text-white font-semibold text-[15px] opacity-90 will-animate animate-fadeIn delay-${(index + 3) * 100} ${textInView ? 'is-visible' : ''}`} data-id="element-79">
                  <span className="text-gold font-black text-xs mr-4 tracking-wider" data-id="element-80">
                    888
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}